import React from 'react'

import { Step, StepLabel, Stepper } from '@material-ui/core'

import { useAutoScheduleStyles } from './styles'

const WALK_STEPS = ['Setup', 'Walk', 'Schedule']

interface StepperProps {
    activeStep: number
}

export const WalkSchedulerStepper = ({ activeStep }: StepperProps) => {
    const classes = useAutoScheduleStyles()

    return (
        <Stepper
            activeStep={activeStep}
            alternativeLabel
            className={classes.headerStepper}
        >
            {WALK_STEPS.map((label) => (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    )
}

interface FrameProps {
    children: React.ReactNode
}

export const WalkSchedulerFrame = ({ children }: FrameProps) => {
    const classes = useAutoScheduleStyles()

    return (
        <div className={classes.walkFlow}>
            <div className={classes.walkFlowBody}>{children}</div>
        </div>
    )
}
